<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/association-introduction">关于我们</router-link></li>
                <li class="currentNode"><a>协会构架</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>关于我们</a></li>
                    <li><router-link to="/layout/association-introduction">协会简介</router-link></li>
                    <li><router-link to="/layout/association-articles">协会章程</router-link></li>
                    <li><router-link to="" class="active">协会构架</router-link></li>
                    <li><router-link to="/layout/join-us">申请入会</router-link></li>
                    <li><router-link to="/layout/call">联系方式</router-link></li>
                </ul>
                <div class="page-content">
                    <h3>协会构架</h3>
                    <img class="association-structure" :src="imgUrl" />
                    <!-- <img class="association-structure" src="@/assets/image/association/association_structure.png" /> -->
                    <!-- <h3>协会成员</h3> -->
                    <!-- <ul class="association-member"> -->
                        <!-- <li v-for="people in peopleList" :key="people.Id">
                            <h4>{{ people.Name }}</h4>
                            <p>{{ people.Rank }}</p>
                            <div class="content-detail" v-html="people.Introduction"></div>
                        </li> -->
                        <!-- <li>
                            <h4>茉欧某某</h4>
                            <p>党委书记、董事长</p>
                            <p>主持公司全面工作，分管审计工作。</p>
                        </li>
                        <li>
                            <h4>茉欧某某</h4>
                            <p>党委书记、董事长</p>
                            <p>主持公司全面工作，分管审计工作。</p>
                        </li> -->
                    <!-- </ul> -->
                    <!-- <h3>协会成员</h3>
                    <ul class="institution-list">
                        <li class="institution-item"  v-for="office in officeList" :key="office.Id">
                            <img :src="office.ImageUrl" />
                            <p>{{ office.Title }}</p>
                        </li>
                    </ul> -->
                    <h3>协会会员</h3>
                    <div>
                        <el-tabs v-model="memberType"  @tab-click="changebannerTab">
                        <el-tab-pane label="省级政府驻京办" name="provinceMember">
                            <ul class="member-enterprise-list">
                                <li class="member-enterprise-item" v-for="member in provinceMemberList" :key="member.Id">{{ member.Name }}</li>
                            </ul>
                        </el-tab-pane>
                        <el-tab-pane label="副省级政府驻京办" name="viceProvinceMember">
                            <ul class="member-enterprise-list">
                                <li class="member-enterprise-item" v-for="member in viceProvinceMemberList" :key="member.Id">{{ member.Name }}</li>
                            </ul>
                        </el-tab-pane>
                        <el-tab-pane label="地市级联络处" name="cityProvinceMember">
                            <ul class="member-enterprise-list">
                                <li class="member-enterprise-item" v-for="member in cityProvinceMemberList" :key="member.Id">{{ member.Name }}</li>
                            </ul>
                        </el-tab-pane>
                        <el-tab-pane label="企业会员" name="vipMember">
                            <ul class="member-enterprise-list">
                                <li class="member-enterprise-item" v-for="member in vipMemberList" :key="member.Id">{{ member.Name }}</li>
                            </ul>
                        </el-tab-pane>
                    </el-tabs>
                    </div>
                    <!-- <ul class="member-enterprise-list">
                        <li class="member-enterprise-item" v-for="member in memberList" :key="member.Id">{{ member.Name }}</li>
                    </ul> -->
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {
    getXiehuiModel,
    getXiehuiVIP
} from '@services/indexService.js'
export default {
    name:"",
    data() {
        return {
            id: 5, // 5
            memberType: 5, // 协会成员
            imgUrl: '',
            memberType: 'provinceMember',
            provinceMemberList: [],
            viceProvinceMemberList: [],
            cityProvinceMemberList: [],
            officeList: [],
            vipMemberList: []
        }
    },
    created() {
        this.getXiehuiModel();
        this.getXiehuiVIPAll();
    },
    methods: {
        handleCurrentChange(pageNum) {

        },
        getXiehuiModel() {
            let params = {
                id: this.id
            };
            getXiehuiModel(params).then(res => {
                console.log(res);
                if (res.Code == 1 && res.Data.length!==0) {
                    this.imgUrl = res.Data.WebSite;
                } else {
                    this.$message.error('协会构架请求失');
                }
            })
        },
        getXiehuiVIPAll() {
            Promise.all([getXiehuiVIP({type: 1}),getXiehuiVIP({type: 2}),getXiehuiVIP({type: 3}),getXiehuiVIP({type: 4})]).then ( res => {
                console.log(res)
                if (res[0].Code !== 1) {
                    this.$message.error("协会成员请求失败");
                } else {
                    this.provinceMemberList = res[0].Data;
                    this.viceProvinceMemberList = res[1].Data;
                    this.cityProvinceMemberList = res[2].Data;
                    this.vipMemberList = res[3].Data;
                }
            })
        },
        changebannerTab() {

        }
    }
}
</script>

<style scoped>
.page-content {
    padding: 30px;
}
.page-content h3{
    text-align:center;
}
.association-structure{
    display: block;
    /* width: 596px; */
    height: 369px;
    margin : 0 auto;
    margin-bottom: 20px;
}
.page-content p {
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 28.64px;
    color: #4E5969;
    margin-bottom: 20px;
    width: 100%;
}
.page-content p:nth-of-type(1){
    text-indent: 0;
    margin-bottom: 0;
}
.association-member h4{
    color: #262626;
    font-size: 18px;
}
.association-member p:nth-of-type(1){
    color:#262626;
}
.association-member p:nth-of-type(2){
    color: #86909C;

}
.institution-list,
.member-enterprise-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}
.institution-item img{
    width: 216px;
    height: 120px;  
}
.institution-item p {
    font-size: 14px;
    text-align:center;
    color: #4E5969;
}
.member-enterprise-item {
    width: 216px;
    height: 68px;
    padding:0 12px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    /* line-height: 68px; */
    text-align: center;
    color: #4E5969;
    font-size: 14px;
    background: #F6F6F6;
    margin-right: 30px;
    margin-bottom: 20px
}
.member-enterprise-list .member-enterprise-item:nth-child(4n) {
    margin-right:0;
}
</style>